import { StrictMode } from 'react';
import { initializeTheme } from '@mybonum/utils';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';

import '@mybonum/ui/styles/index.scss';

initializeTheme();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>
);
